import React from 'react';
import CommandList from "components/admin/commands/List";

function CommandsView() {
  return (
    <>
      <div className="content container-fluid p-5">

        <div className="page-header mb-3">
          <div className="row align-items-end">
            <div className="col-sm mb-2 mb-sm-0">
              <h1 className="page-header-title">Comandos</h1>
            </div>
          </div>
        </div>

        <CommandList />

      </div>
    </>
  );
}

export default CommandsView;